import script from "./HoverPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./HoverPopover.vue?vue&type=script&setup=true&lang=js"

import "./HoverPopover.vue?vue&type=style&index=0&id=19a5c3f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a5c3f2"]])

export default __exports__